/**
 * @file Generated by js-routes 2.3.6. Based on Rails 7.2.3.1 routes of OpslevelCom::Application.
 * @version 39662c6030d8eeb3e5d420ffcd0772b950f1fb0a2d539dfa797165e9b32a33c7
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    true
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/levels
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_levels_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[6,"levels"]]]]);

/**
 * Generates rails route to
 * /account/permissions
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_permissions_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[6,"permissions"]]]]);

/**
 * Generates rails route to
 * /account/plan
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_plan_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[6,"plan"]]]]);

/**
 * Generates rails route to
 * /account/plan/success
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_plan_success_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[6,"success"]]]]]]);

/**
 * Generates rails route to
 * /account/property_definitions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_property_definitions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"property_definitions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /actions
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const actions_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"actions"]]);

/**
 * Generates rails route to
 * /actions/:uuid/status/:status(.:format)
 * @param {any} uuid
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const actions_status_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"status":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"actions"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/spoof/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_spoof_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"spoof"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stop_spoof(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_stop_spoof_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stop_spoof"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/service_level/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"service_level"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/account_repositories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_repositories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account_repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/components/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_component_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/components/:component_id/deploys(.:format)
 * @param {any} component_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_component_deploys_path = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"deploys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/components/:component_id/service_repositories(.:format)
 * @param {any} component_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_component_service_repositories_path = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"service_repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/components/:component_id/tools(.:format)
 * @param {any} component_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_component_tools_path = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/fail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_fail_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"fail"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_health_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/integrations/datadog/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_integrations_datadog_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"datadog"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/integrations/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_integrations_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/lifecycles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lifecycle_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lifecycles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/providers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_provider_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/providers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_providers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"providers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/repositories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_repositories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/services/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/services/:service_id/deploys(.:format)
 * @param {any} service_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_service_deploys_path = /*#__PURE__*/ __jsr.r({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"deploys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/service_repositories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_service_repository_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"service_repositories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/services/:service_id/service_repositories(.:format)
 * @param {any} service_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_service_service_repositories_path = /*#__PURE__*/ __jsr.r({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"service_repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/services/:service_id/tools(.:format)
 * @param {any} service_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_service_tools_path = /*#__PURE__*/ __jsr.r({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_signup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/signup/reject(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_signup_reject_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/tiers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tier_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_tokens
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tokens_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"api_tokens"]]);

/**
 * Generates rails route to
 * /api/tools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/feature_flags/batch_action(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_internal_account_feature_flags_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/lifecycles/batch_action(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_internal_account_lifecycles_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"lifecycles"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/tiers/batch_action(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_internal_account_tiers_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/users/batch_action(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_internal_account_users_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_internal_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_checkout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /billing/checkout/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_billing_checkout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog/infrastructure/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_infrastructure_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"infrastructure"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/infrastructure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_infrastructures_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"infrastructure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog/packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog/systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_system_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_systems_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checks/:check_id/download_yaml(.:format)
 * @param {any} check_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_download_yaml_path = /*#__PURE__*/ __jsr.r({"check_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"check_id"],[2,[7,"/"],[2,[6,"download_yaml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checklists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checklists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checklists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scorecards/:id/checks/new(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checks_new_scorecard_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /components/:id/:tab(.:format)
 * @param {any} id
 * @param {any} tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_tab_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /component_template_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_template_run_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"component_template_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /component_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"component_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const components_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /csrf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csrf_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"csrf"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customization/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customization_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customization_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customization/team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customization_team_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documentation
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentation_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"documentation"]]);

/**
 * Generates rails route to
 * /upload/documents/sbom/:resource_id(.:format)
 * @param {any} resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documents_resource_webhook_path = /*#__PURE__*/ __jsr.r({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"sbom"],[2,[7,"/"],[2,[3,"resource_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/repositories/:id/download_yaml(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_yaml_api_repository_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_yaml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:id/download_yaml(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_yaml_component_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_yaml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:id/download_yaml(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_yaml_service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_yaml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/edit
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[6,"edit"]]]]);

/**
 * Generates rails route to
 * /account/property_definitions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_property_definition_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"property_definitions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/feature_flags/:id/edit(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_account_feature_flag_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/lifecycles/:id/edit(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_account_lifecycle_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"lifecycles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/tiers/:id/edit(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_account_tier_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/users/:id/edit(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_account_user_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/edit_maintenance_agent_plan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_maintenance_agent_plan_internal_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_maintenance_agent_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /manage_actions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_manage_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scorecards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scorecard_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:slug/edit
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /filters
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filters_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"filters"]]);

/**
 * Generates rails route to
 * /free_trial_getting_started(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_trial_getting_started_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"free_trial_getting_started"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /getting_started(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const getting_started_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"getting_started"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /graphiql(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphiql_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"graphiql"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /graphql(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphql_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"graphql"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /initiatives/:slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiative_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true}}, [2,[7,"/"],[2,[6,"initiatives"],[2,[7,"/"],[3,"slug"]]]]);

/**
 * Generates rails route to
 * /initiatives
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiatives_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"initiatives"]]);

/**
 * Generates rails route to
 * /integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/aws/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_aws_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"aws"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/azure_devops/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_azure_devops_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"azure_devops"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/azure_devops/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_azure_devops_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"azure_devops"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/azure_devops/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_azure_devops_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"azure_devops"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/azure_resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_azure_resources_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"azure_resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/descriptor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_descriptor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"descriptor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/init_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_init_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"init_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/install(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_install_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"install"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/repository/created(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_repository_created_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"created"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/repository/deleted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_repository_deleted_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"deleted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/repository/push(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_repository_push_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"push"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/repository/transfer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_repository_transfer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/repository/updated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_repository_updated_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"updated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/bitbucket/uninstall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_bitbucket_uninstall_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/check/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_check_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"check"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/check(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_check_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"check"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/custom/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_custom_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/custom_event/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_custom_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"custom_event"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/custom_event(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_custom_event_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"custom_event"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/custom/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_custom_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/datadog/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_datadog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"datadog"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/datadog/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_datadog_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"datadog"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/deploy/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_deploy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"deploy"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/deploy(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_deploy_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"deploy"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/document/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/document(/:uuid)/:resource_type/:resource_alias/:subtype(.:format)
 * @param {any} resource_type
 * @param {any} resource_alias
 * @param {any} subtype
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_document_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"resource_type":{"r":true},"resource_alias":{"r":true},"subtype":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"document"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[2,[7,"/"],[2,[3,"resource_type"],[2,[7,"/"],[2,[3,"resource_alias"],[2,[7,"/"],[2,[3,"subtype"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/fire_hydrant/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_fire_hydrant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"fire_hydrant"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/fire_hydrant/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_fire_hydrant_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"fire_hydrant"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/github/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_github_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"github"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/github/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_github_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"github"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/github/init_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_github_init_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"github"],[2,[7,"/"],[2,[6,"init_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/github/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_github_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"github"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/gitlab/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_gitlab_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gitlab"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/gitlab/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_gitlab_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gitlab"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/gitlab/init_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_gitlab_init_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gitlab"],[2,[7,"/"],[2,[6,"init_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/gitlab/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_gitlab_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gitlab"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/google_cloud/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_google_cloud_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/incident_io/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_incident_io_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"incident_io"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/incident_io/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_incident_io_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"incident_io"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/jira/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_jira_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/jira/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_jira_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/jira/init_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_jira_init_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"init_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/jira/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_jira_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/kubernetes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_kubernetes_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"kubernetes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/kubernetes/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_kubernetes_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"kubernetes"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/microsoft_teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_microsoft_team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/microsoft_teams/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_microsoft_teams_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_teams"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/microsoft_teams/init_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_microsoft_teams_init_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_teams"],[2,[7,"/"],[2,[6,"init_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/microsoft_teams/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_microsoft_teams_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_teams"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/new_relic/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_new_relic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new_relic"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/new_relic/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_new_relic_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new_relic"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/opsgenie/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_opsgenie_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"opsgenie"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/opsgenie/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_opsgenie_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"opsgenie"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/opsgenie/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_opsgenie_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"opsgenie"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/pagerduty/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_pagerduty_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"pagerduty"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/pagerduty/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_pagerduty_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"pagerduty"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/pagerduty/init_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_pagerduty_init_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"pagerduty"],[2,[7,"/"],[2,[6,"init_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/pagerduty/webhook(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_pagerduty_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"pagerduty"],[2,[7,"/"],[2,[6,"webhook"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/payload/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_payload_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"payload"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/payload(/:uuid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_payload_webhook_path = /*#__PURE__*/ __jsr.r({"uuid":{},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"payload"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/scim/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_scim_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/scim/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_scim_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/slack/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_slack_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/slack/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_slack_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/slack/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_slack_finish_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/slack/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_slack_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/snyk/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_snyk_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"snyk"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/sonarqube/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_sonarqube_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"sonarqube"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/sonarqube_cloud/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_sonarqube_cloud_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"sonarqube_cloud"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/terraform/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_terraform_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"terraform"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/terraform/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_terraform_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"terraform"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/feature_flags/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_feature_flag_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/feature_flags(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_feature_flags_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/lifecycles/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_lifecycle_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"lifecycles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/lifecycles(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_lifecycles_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"lifecycles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/tiers/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_tier_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/tiers(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_tiers_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"tiers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/users/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_user_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/users(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_account_users_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/blackhole_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_blackhole_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"blackhole_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/blackhole_dashboard/delete_rule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_blackhole_dashboard_delete_rule_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"blackhole_dashboard"],[2,[7,"/"],[2,[6,"delete_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/blackhole_dashboard/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_blackhole_dashboard_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"blackhole_dashboard"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/customer_support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_customer_support_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"customer_support"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/customer_support/force_sync_custom_integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_customer_support_force_sync_custom_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"customer_support"],[2,[7,"/"],[2,[6,"force_sync_custom_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_flag_definitions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_feature_flag_definition_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_flag_definitions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_flag_definitions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_feature_flag_definitions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_flag_definitions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_flag_definitions/flag_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_feature_flag_definitions_flag_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_flag_definitions"],[2,[7,"/"],[2,[6,"flag_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_flag_definitions/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_feature_flag_definitions_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_flag_definitions"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/logs/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_logs_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/logs/json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_logs_json_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/logs/xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_logs_xml_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/reload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_reload_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"reload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/runners_job_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_runners_job_run_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"runners_job_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/runners_job_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_runners_job_runs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"runners_job_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/system_toggles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_system_toggles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"system_toggles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/system_toggles/disable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_system_toggles_disable_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"system_toggles"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/system_toggles/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_system_toggles_enable_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"system_toggles"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/theming(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_theming_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"theming"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_agent/:slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_agent_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true}}, [2,[7,"/"],[2,[6,"maintenance_agent"],[2,[7,"/"],[3,"slug"]]]]);

/**
 * Generates rails route to
 * /maintenance_agent
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_agents_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"maintenance_agent"]]);

/**
 * Generates rails route to
 * /manage_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_actions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage_actions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/property_definitions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_property_definition_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"property_definitions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /components/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_component_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /component_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_component_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"component_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /initiatives/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_initiative_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"initiatives"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /integrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/feature_flags/new(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_account_feature_flag_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/lifecycles/new(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_account_lifecycle_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"lifecycles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/tiers/new(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_account_tier_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/users/new(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_account_user_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_agent/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_maintenance_agent_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"maintenance_agent"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /manage_actions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_manage_action_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage_actions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scorecards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_scorecard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /services/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_service_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_team_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /not_found
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const not_found_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"not_found"]]);

/**
 * Generates rails route to
 * /oauth_applications
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_applications_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"oauth_applications"]]);

/**
 * Generates rails route to
 * /oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/oauth-authorization-server(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_server_metadata_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"oauth-authorization-server"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_register_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/oauth-protected-resource/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const protected_resource_metadata_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"oauth-protected-resource"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recommendations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recommendations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reports/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/cost(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_cost_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"cost"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/rubric(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_rubric_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rubric"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /repositories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repositories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"repositories"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /repositories/:id/documents/tech(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repositories_document_tech_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"tech"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /repositories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repository_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/users/:id/resend_invite(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invite_internal_account_user_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/runners_job_runs/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_internal_runners_job_run_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"runners_job_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /rubrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rubrics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rubrics/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rubrics_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/schedule_plan_change(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_plan_change_internal_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule_plan_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scim/Users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scim/Groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_Group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scim/Groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_Groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scim/Users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_User_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scim/Users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_Users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scim
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_scimitar_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"scim"]]);

/**
 * Generates rails route to
 * /scim/ResourceTypes/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_scimitar_scim_resource_type_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"scim"]],[7,"/"]],[2,[6,"ResourceTypes"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scim/ResourceTypes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_scimitar_scim_resource_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"scim"]],[7,"/"]],[2,[6,"ResourceTypes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scim/Schemas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_scimitar_scim_schemas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"scim"]],[7,"/"]],[2,[6,"Schemas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scim/ServiceProviderConfig(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scim_scimitar_scim_service_provider_configuration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"scim"]],[7,"/"]],[2,[6,"ServiceProviderConfig"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scorecards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scorecard_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scorecards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scorecards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scorecards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_blob_redirect_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /services/:id/:tab(.:format)
 * @param {any} id
 * @param {any} tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_tab_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /service_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"service_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /service_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_templates_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"service_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const services_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/users/:id/spoof_user(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spoof_user_internal_account_user_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spoof_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/checkout/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_billing_checkout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /suggestions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggestions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"suggestions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"teams"]]);

/**
 * Generates rails route to
 * /thena_identity_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thena_identity_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"thena_identity_verification"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/activate(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_activate_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/deactivate(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_deactivate_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/invalidate_session(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invalidate_session_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"invalidate_session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/resend_invite(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_resend_invite_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"resend_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/saml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_saml_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/saml/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_saml_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"users"]]);

/**
 * Generates rails route to
 * /users/auth/saml/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_auth_saml_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_password_edit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_password_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sso/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sso_sign_in_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vaults/secrets
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vaults_secrets_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"vaults"],[2,[7,"/"],[6,"secrets"]]]]);

/**
 * Generates rails route to
 * /welcome
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"welcome"]]);

